import {
    request,
} from '../request.js'

// 每日更新列表
export function dailyUpdateList(data) {
    return request({
        url: '/web/back/sys/dayUpdate/list',
        method: 'post',
        data
    })
}
//  查询有每日更新的企业
export function allEnterprise(data) {
    return request({
        url: '/web/back/sys/unit/selectList',
        method: 'get',
        params: data
    })
}
